 import $ from 'jquery';
 import { trackOperations as trackLegacy } from './legacy-analytics';
 import { trackOperations as trackAnalytics4 } from './google-analytics4';
 import { redirect } from './redirections.js';
 import * as resemPage  from './resem-page.js';


 function getCurrentPage() {
     if (resemPage.getType() === "projects serp") {
         return "projects serp";
     } else if (resemPage.getOperation() === "rent") {
         return  "rent";
     }
     return "sale";
 }

 export function init() {
     $(".byOperation").on('click', 'a', function () {
         let clickedType = this.getAttribute("data-type");
         trackLegacy(clickedType);
         let currentPage = getCurrentPage();
         trackAnalytics4(clickedType, currentPage);
         redirect(this.href);
     });
 }